import script from "./VipLevel.vue?vue&type=script&setup=true&lang=js"
export * from "./VipLevel.vue?vue&type=script&setup=true&lang=js"

import "./VipLevel.vue?vue&type=style&index=0&id=db9bd2b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db9bd2b4"]])

export default __exports__